<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <organization-picker
          v-if="loggedInUser.Contracts.length > 1"
          :organizations="loggedInUser.Contracts"
          v-model="selectedOrganization">
        </organization-picker>
        <br>
        <calendar-input :options="dateField" v-model="date" @input="refresh"></calendar-input>
        <nav-tab :tab-count="4" ref="tabs">
          <!-- Reservations -->
          <div title="Reservations" slot="tab1" icon="fa-car">
            <div class="card card-primary">
              <div class="card-header">
                {{ dashboard.reservationOverview.title }}
              </div>
              <div class="list-group list-group-flush" v-if="loggedInUser.AccountType.financeAdministrator">
                <div class="list-group-item">
                  <strong>Reservations On This Page</strong>
                  <span class="ml-2 badge badge-info">{{ dashboard.reservationOverview.count }}</span>
                </div>
                <div class="list-group-item">
                  <strong>Total Hours</strong>
                  <span class="ml-2 badge badge-primary">{{ dashboard.reservationOverview.totalHours }} hours</span>
                </div>
                <div class="list-group-item">
                  <strong>Estimated Revenue</strong>
                  <span class="ml-2 badge badge-success">{{ dashboard.reservationOverview.totalRevenue | to_dollar_amount }}</span>
                </div>
                <div class="list-group-item">
                  <strong>Stripe Transfer</strong>
                  <template v-if="dashboard.balance">
                    <span class="ml-2 badge badge-default">{{ dashboard.balance | stripe_currency }}</span>
                    <span class="small">Transfer will arrive on {{ dashboard.balanceDate | short_date_format }}</span>
                  </template>
                  <template v-else>
                    <span class="ml-2 badge badge-danger">No Transfer Available</span>
                    <span class="small">Due to incomplete day or public holiday</span>
                  </template>
                </div>
              </div>
              <div class="card-body">
                <responsive-table
                  v-if="dashboard.reservationOverview.rows.length"
                  :table="dashboard.reservationOverview"
                  :hideTitle="true">
                </responsive-table>
                <div v-else class="alert alert-info">
                  There are no reservations for today.
                </div>
              </div>
            </div>
          </div>
          <!-- Maintenance -->
          <div title="Maintenance" slot="tab2" icon="fa-wrench">
            <div class="card card-primary">
              <div class="card-header">
                {{ dashboard.maintenanceOverview.title }}
                <span class="badge badge-primary">
                  {{ dashboard.maintenanceOverview.count }} results
                </span>
              </div>
              <div class="card-body">
                <responsive-table
                  v-if="dashboard.maintenanceOverview.rows.length"
                  :table="dashboard.maintenanceOverview"
                  :hideTitle="true">
                </responsive-table>
                <div v-else class="alert alert-info">
                  There are no vehicles currently on maintenance.
                </div>
              </div>
            </div>
          </div>
          <!-- Restrictions -->
          <div title="Restrictions" slot="tab3" icon="fa-exclamation-triangle">
            <div class="card card-primary">
              <div class="card-header">
                {{ dashboard.restrictionOverview.title }}
                <span class="badge badge-primary">
                  {{ dashboard.restrictionOverview.count }} results
                </span>
              </div>
              <div class="card-body">
                <responsive-table
                  v-if="dashboard.restrictionOverview.rows.length"
                  :table="dashboard.restrictionOverview"
                  :hideTitle="true">
                </responsive-table>
                <div v-else class="alert alert-info">
                  There are currently no car restrictions.
                </div>
              </div>
            </div>
          </div>
          <!-- Battery Warnings -->
          <div title="Battery Warnings" slot="tab4" icon="fa-battery-half">
            <div class="card card-primary">
              <div class="card-header">
                {{ dashboard.batteryOverview.title }}
                <span class="badge badge-primary">
                  {{ dashboard.batteryOverview.count }} results
                </span>
              </div>
              <div class="card-body">
                <responsive-table
                  v-if="dashboard.batteryOverview.rows.length"
                  :table="dashboard.batteryOverview"
                  :hideTitle="true">
                </responsive-table>
                <div v-else class="alert alert-info">
                  No low battery warnings.
                </div>
              </div>
            </div>
          </div>
        </nav-tab>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarInput from '@/components/inputs/CalendarInput'
import OrganizationPicker from '@/components/inputs/OrganizationPicker'
import ResponsiveTable from '@/components/ResponsiveTable'
import NavTab from '@/components/NavTab'
import { LOAD_DASHBOARD } from '@/vuex/types'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminHome',
  components: {
    CalendarInput,
    OrganizationPicker,
    ResponsiveTable,
    NavTab
  },
  data () {
    return {
      dateField: {
        name: 'date',
        label: 'Select a Date',
        noLabel: true,
        inline: true
      },
      date: new Date(),
      selectedOrganization: false
    }
  },
  computed: {
    ...mapGetters([
      'dashboard',
      'loggedInUser'
    ])
  },
  async mounted () {
    await this.$store.dispatch(LOAD_DASHBOARD, { date: this.date, selectedOrganization: this.selectedOrganization.uuid })
  },
  methods: {
    async refresh () {
      await this.$store.dispatch(LOAD_DASHBOARD, { date: this.date, selectedOrganization: this.selectedOrganization.uuid })
    }
  },
  watch: {
    selectedOrganization () {
      this.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Home.vue